<template>
    <!-- Generato da claude — Prenotazioni redesign Proposta A -->
    <div>
        <div class="row g-3">

            <!-- Attività disponibili -->
            <div class="col-md-7">
                <div class="card">
                    <div class="card-header card-header-background">
                        <span class="dk-header-title">📅 Attività disponibili</span>
                        <span class="dk-header-badge" v-if="arrayAttivita.length > 0">{{arrayAttivita.length}}</span>
                    </div>
                    <div class="card-body p-0">
                        <div v-if="arrayAttivita.length === 0" class="dk-empty-state">
                            <span class="dk-empty-state-icon">🏊</span>
                            Nessuna attività prenotabile al momento
                        </div>
                        <div class="dk-list-item"
                            v-for="attivita in arrayAttivita"
                            :key="attivita.ID_ATTIVITA">
                            <div class="dk-list-date">
                                <span class="dk-list-date-day">{{formatDay(attivita.DATA)}}</span>
                                <span class="dk-list-date-month">{{formatMonth(attivita.DATA)}}</span>
                            </div>
                            <div class="dk-list-info">
                                <div class="dk-list-title">{{attivita.DESCRIZIONE}}</div>
                                <div class="dk-list-sub">
                                    {{filters.formatTime(attivita.ORA_INIZIO)}} – {{filters.formatTime(attivita.ORA_FINE)}}
                                    &nbsp;·&nbsp; {{attivita.TOT}} / {{attivita.MAX_SOCI}} posti
                                </div>
                            </div>
                            <div class="dk-list-action">
                                <button class="btn btn-sm btn-dk-orange" @click.stop="prenotaAttivita(attivita)">
                                    Prenota
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Le mie prenotazioni -->
            <div class="col-md-5">
                <div class="card">
                    <div class="card-header card-header-background">
                        <span class="dk-header-title">✅ Le mie prenotazioni</span>
                        <span class="dk-header-badge" v-if="arrayPrenotazioni.length > 0">{{arrayPrenotazioni.length}}</span>
                    </div>
                    <div class="card-body p-0">
                        <div v-if="arrayPrenotazioni.length === 0" class="dk-empty-state">
                            <span class="dk-empty-state-icon">🗓️</span>
                            Nessuna prenotazione attiva
                        </div>
                        <div class="dk-list-item"
                            v-for="attivita in arrayPrenotazioni"
                            :key="attivita.ID_PRENOTAZIONE">
                            <div class="dk-list-date">
                                <span class="dk-list-date-day">{{formatDay(attivita.DATA)}}</span>
                                <span class="dk-list-date-month">{{formatMonth(attivita.DATA)}}</span>
                            </div>
                            <div class="dk-list-info">
                                <div class="dk-list-title">{{attivita.DESCRIZIONE}}</div>
                                <div class="dk-list-sub">
                                    {{filters.formatTime(attivita.ORA_INIZIO)}} – {{filters.formatTime(attivita.ORA_FINE)}}
                                    <span v-if="attivita.NOTE"> · {{attivita.NOTE}}</span>
                                </div>
                            </div>
                            <div class="dk-list-action">
                                <button class="btn btn-sm btn-outline-danger" @click.stop="annullaPrenotazione(attivita)">
                                    Annulla
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'Prenotazioni',
    data: function() {
        return {
            filters: global.filters,
            arrayAttivita: [],
            arrayPrenotazioni: [],
        }
    },
    methods: {
        formatDay(d)   { return global.moment(d).format('DD'); },
        formatMonth(d) {
            const mesi = ['GEN','FEB','MAR','APR','MAG','GIU','LUG','AGO','SET','OTT','NOV','DIC'];
            return mesi[global.moment(d).month()];
        },

        prenotaAttivita(attivita) {
            const nomeSocio = this.$root.utente.NOME + ' ' + this.$root.utente.COGNOME;
            utils.alert.confirm(
                'Prenota <strong>' + attivita.DESCRIZIONE + '</strong><br/>' +
                this.filters.formatDate(attivita.DATA) + ' · ' +
                this.filters.formatTime(attivita.ORA_INIZIO) + ' – ' + this.filters.formatTime(attivita.ORA_FINE) + '<br/>' +
                'per <strong>' + nomeSocio + '</strong>?',
                (alertConfirm) => {
                    utils.ajax('deskalo/attivita/prenota', {
                        ID_CORSO: attivita.ID_CORSO,
                        ID_SOCIO: attivita.ID_SOCIO,
                        ID_DATA: attivita.ID_DATA,
                        ORA_INIZIO: attivita.ORA_INIZIO,
                        ORA_FINE: attivita.ORA_FINE,
                        NOTE: alertConfirm.NOTE,
                    }, (response) => {
                        if (response.esito == 0) {
                            utils.alert.success(response.messaggio);
                            this.loadData();
                        }
                    });
                },
                this.$root, 'Conferma prenotazione', null, 'Prenota', 'Annulla', 'fa-calendar-check', true
            );
        },

        annullaPrenotazione(attivita) {
            utils.alert.confirm(
                'Annullare la prenotazione di <strong>' + attivita.DESCRIZIONE + '</strong><br/>' +
                this.filters.formatDate(attivita.DATA) + ' · ' +
                this.filters.formatTime(attivita.ORA_INIZIO) + ' – ' + this.filters.formatTime(attivita.ORA_FINE) + '?',
                () => {
                    utils.ajax('/deskalo/attivita/annulla', { ID_PRENOTAZIONE: attivita.ID_PRENOTAZIONE }, (response) => {
                        if (response.esito == 0) {
                            utils.alert.success(response.messaggio);
                            this.loadData();
                        }
                    });
                },
                this.$root
            );
        },

        loadData() {
            utils.ajax('/deskalo/prenotazioni/startup', {}, (response) => {
                this.arrayAttivita     = response.data.ATTIVITA;
                this.arrayPrenotazioni = response.data.PRENOTAZIONI_ATTIVE;
            });
        },
    },
    created() {
        this.loadData();
    },
}
</script>
